import React from 'react';
import UIRegions from 'shared/constants/UIRegions';
import Modal from 'shared/components/misc/modal.jsx';
import GlobalElementsActivation from 'shared/components/team/globalElementsActivation';

/**
 * Global Elements Activation Modal
 */
export default React.createClass({
  displayName: 'GlobalElementsActivationModal',

  render() {
    return (
      <Modal
        className="modal-generic-wrapper upgrade-alert-modal"
        headerClassName="modal-generic-header"
        name={UIRegions.GlobalElementsActivationModal}
      >
        <GlobalElementsActivation />
      </Modal>
    );
  },
});
